// UTM helper for the Arkema landing page.
const UTM_PARAMS: Record<string, string> = {
  utm_source: "arkema-wl",
  utm_medium: "arkema-wl",
  utm_campaign: "arkema-wl",
};

export const withUtm = (href: string): string => {
  if (!href) return href;
  if (!/^https?:\/\//i.test(href)) return href;
  try {
    const url = new URL(href);
    Object.entries(UTM_PARAMS).forEach(([k, v]) => {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, v);
      }
    });
    return url.toString();
  } catch {
    return href;
  }
};

const LOCALE_PREFIX_RE = /^\/(?:en-us|es-es|fr-fr)(?=\/|$)/i;

/**
 * Localize an outgoing naboo.app URL based on the current page language.
 * - Only rewrites when lang === "es" (FR is the default and stays untouched).
 * - Skips arkema.naboo.app (client subdomain has no language variant).
 * - For www.naboo.app: prefixes the path with /es-es/.
 * - For *.ext.naboo.app: swaps the leading subdomain (e.g. fr.ext -> es.ext).
 */
export const localizeNabooUrl = (href: string, lang: "fr" | "es"): string => {
  if (!href || lang !== "es") return href;
  if (!/^https?:\/\//i.test(href)) return href;
  try {
    const url = new URL(href);
    const host = url.hostname.toLowerCase();
    if (!host.endsWith("naboo.app")) return href;
    if (host === "arkema.naboo.app") return href;

    if (host === "www.naboo.app" || host === "naboo.app") {
      const stripped = url.pathname.replace(LOCALE_PREFIX_RE, "") || "/";
      url.pathname = "/es-es" + (stripped === "/" ? "" : stripped);
      return url.toString();
    }

    // *.ext.naboo.app -> swap leading subdomain to "es"
    const extMatch = host.match(/^([^.]+)\.ext\.naboo\.app$/);
    if (extMatch) {
      url.hostname = "es.ext.naboo.app";
      return url.toString();
    }

    return href;
  } catch {
    return href;
  }
};

export const withUtmLang = (href: string, lang: "fr" | "es"): string =>
  withUtm(localizeNabooUrl(href, lang));
